import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The `}<inlineCode parentName="p">{`capture()`}</inlineCode>{` method has an optional argument `}<inlineCode parentName="p">{`sendFeatureFlags`}</inlineCode>{`, which is set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` by default. By setting this to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, feature flag information will automatically be sent with the event.`}</p>
    <p>{`Note that by doing this, PostHog will make an additional request to fetch feature flag information before capturing the event. So this method is only recommended if you don't mind the extra API call and delay.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
    distinctId: 'distinct_id_of_your_user',
    event: 'event_name',
    sendFeatureFlags: true,
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      